import { createApi } from '@reduxjs/toolkit/query/react';

import { apiProdaConnection } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import {
  ProdaActivationRequest,
  ProdaConnection,
  ProdaConnectionTestResult,
  ProdaDetailsUpdate,
} from '~support-at-home/models/prodaConnection';

export const prodaConnectionApi = createApi({
  reducerPath: 'sahProdaConnectionApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiProdaConnection }),
  tagTypes: ['prodaConnection'],
  endpoints: (builder) => ({
    getProdaConnection: builder.query<ProdaConnection, void>({
      query: () => ({ url: '', method: 'GET' }),
      transformResponse: (payload) => unwrap<ProdaConnection>(payload),
      providesTags: [{ type: 'prodaConnection', id: 'CURRENT' }],
    }),
    activateProdaConnection: builder.mutation<ProdaConnection, ProdaActivationRequest>({
      query: (body) => ({ url: '/activate', method: 'POST', body }),
      transformResponse: (payload) => unwrap<ProdaConnection>(payload),
      invalidatesTags: [{ type: 'prodaConnection', id: 'CURRENT' }],
    }),
    updateProdaConnectionDetails: builder.mutation<ProdaConnection, ProdaDetailsUpdate>({
      query: (body) => ({ url: '', method: 'PATCH', body }),
      transformResponse: (payload) => unwrap<ProdaConnection>(payload),
      invalidatesTags: [{ type: 'prodaConnection', id: 'CURRENT' }],
    }),
    testProdaConnection: builder.mutation<ProdaConnectionTestResult, void>({
      query: () => ({ url: '/test', method: 'POST' }),
      transformResponse: (payload) => unwrap<ProdaConnectionTestResult>(payload),
      invalidatesTags: [{ type: 'prodaConnection', id: 'CURRENT' }],
    }),
    disconnectProdaConnection: builder.mutation<ProdaConnection, void>({
      query: () => ({ url: '', method: 'DELETE' }),
      transformResponse: (payload) => unwrap<ProdaConnection>(payload),
      invalidatesTags: [{ type: 'prodaConnection', id: 'CURRENT' }],
    }),
  }),
});

export const {
  useGetProdaConnectionQuery,
  useActivateProdaConnectionMutation,
  useUpdateProdaConnectionDetailsMutation,
  useTestProdaConnectionMutation,
  useDisconnectProdaConnectionMutation,
} = prodaConnectionApi;
